import { NgModule } from '@angular/core';
import { MarketplaceDetailsV2Component } from './marketplace-v2/marketplace-details-v2/marketplace-details-v2.component';
import { MarketplaceListV2Component } from './marketplace-v2/marketplace-list-v2/marketplace-list-v2.component';
import { MarketplaceListItemV2Component } from './marketplace-v2/marketplace-list-item-v2/marketplace-list-item-v2.component';

@NgModule({
  declarations: [],
  imports: [MarketplaceDetailsV2Component, MarketplaceListV2Component, MarketplaceListItemV2Component],
  exports: [MarketplaceDetailsV2Component, MarketplaceListV2Component, MarketplaceListItemV2Component],
})
export class MarketplaceModule {}
